import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
    EXPENSE_RESOURCES,
    IExpense,
    SUBTOTAL,
    UNIT_PRICE,
} from './expense-form';

export function useSetFirstExpenseResourceItem() {
    const rx = useFormContext();
    const setFirstExpenseResourceItem = useMemo(() => {
        return () => {
            const expenseResources = rx.getValues(
                EXPENSE_RESOURCES,
            ) as IExpense['expense_resources'];

            const subtotal = rx.getValues(SUBTOTAL) as IExpense['subtotal'];

            if (
                expenseResources.length === 1 &&
                expenseResources[0].units &&
                Number(expenseResources[0].units) === 1
            ) {
                if (!Number.isNaN(Number(subtotal))) {
                    rx.setValue(
                        `${EXPENSE_RESOURCES}.0.${UNIT_PRICE}`,
                        subtotal,
                    );
                } else {
                    rx.setValue(`${EXPENSE_RESOURCES}.0.${UNIT_PRICE}`, 0);
                }
            }
        };
    }, [rx]);
    return { setFirstExpenseResourceItem: setFirstExpenseResourceItem };
}
